/** Ponte fina para a ferramenta de analytics (GTM/GA via `dataLayer`).
 *  Nunca inclua dado pessoal nos parâmetros: nome, telefone, endereço etc.
 *  não entram aqui, só o nome do evento e metadados de UI (ex.: a posição
 *  do botão clicado). */
export function trackEvent(nome, parametros = {}) {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: nome, ...parametros });
}
